/* S&R Corporate Gifting — small behaviours for the sr-cg-* sections.
   Swipe-row dots and arrows, FAQ "show all", folding form fields,
   jump links to sections, and the sticky quote bar. Safe to load more than once. */
(function () {
  var MOBILE = window.matchMedia('(max-width: 798px)');
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function each(root, sel, fn) {
    Array.prototype.forEach.call(root.querySelectorAll(sel), fn);
  }

  function initSwipe(track) {
    if (track.getAttribute('data-sr-ready') === '1') { return; }
    track.setAttribute('data-sr-ready', '1');
    var items = Array.prototype.slice.call(track.children);
    if (items.length === 1 || items.length === 0) { return; }
    var cur = 0;
    var nav = document.createElement('div');
    nav.className = 'sr-cg-swipe-nav';
    var dots = items.map(function (item, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'sr-cg-dot';
      b.setAttribute('aria-label', 'Show card ' + (i + 1) + ' of ' + items.length);
      b.addEventListener('click', function () { go(i); });
      nav.appendChild(b);
      return b;
    });
    function arrow(cls, txt, label, step) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'sr-cg-arrow ' + cls;
      b.textContent = txt;
      b.setAttribute('aria-label', label);
      b.addEventListener('click', function () { go(cur + step); });
      nav.appendChild(b);
      return b;
    }
    var prev = arrow('sr-cg-arrow--prev', '←', 'Previous card', -1);
    var next = arrow('sr-cg-arrow--next', '→', 'Next card', 1);
    track.parentNode.insertBefore(nav, track.nextSibling);

    function pad() { return parseFloat(getComputedStyle(track).scrollPaddingLeft) || 0; }
    function go(i) {
      i = Math.max(0, Math.min(items.length - 1, i));
      var delta = items[i].getBoundingClientRect().left - track.getBoundingClientRect().left - pad();
      track.scrollBy({ left: delta, behavior: reduce ? 'auto' : 'smooth' });
    }
    function update() {
      var base = track.getBoundingClientRect().left + pad();
      var best = 0, bestDist = Infinity;
      items.forEach(function (item, i) {
        var d = Math.abs(item.getBoundingClientRect().left - base);
        if (bestDist > d) { bestDist = d; best = i; }
      });
      if (track.scrollLeft + track.clientWidth >= track.scrollWidth - 2) { best = items.length - 1; }
      cur = best;
      dots.forEach(function (d, i) { d.setAttribute('aria-current', i === cur ? 'true' : 'false'); });
      prev.disabled = cur === 0;
      next.disabled = cur === items.length - 1;
    }
    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) { return; }
      ticking = true;
      requestAnimationFrame(function () { ticking = false; update(); });
    }, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function initFaq(faq) {
    if (faq.getAttribute('data-sr-ready') === '1') { return; }
    faq.setAttribute('data-sr-ready', '1');
    if (MOBILE.matches) {
      each(faq, 'details[open]', function (d) { d.removeAttribute('open'); });
    }
    var btn = faq.nextElementSibling;
    if (btn && btn.classList.contains('sr-cg-faq-all')) {
      btn.addEventListener('click', function () { faq.classList.add('is-all'); });
    }
  }

  function initFold(btn) {
    if (btn.getAttribute('data-sr-ready') === '1') { return; }
    btn.setAttribute('data-sr-ready', '1');
    var panel = btn.nextElementSibling;
    if (!panel) { return; }
    btn.addEventListener('click', function () {
      var open = panel.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  function initSticky(bar) {
    if (bar.getAttribute('data-sr-ready') === '1') { return; }
    bar.setAttribute('data-sr-ready', '1');
    if (!('IntersectionObserver' in window)) { bar.classList.add('is-on'); return; }
    var hero = document.querySelector('.sr-cg--hero');
    var form = document.getElementById('sr-cg-quote');
    var heroIn = !!hero, formIn = false;
    function set() { bar.classList.toggle('is-on', !heroIn && !formIn); }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.target === hero) { heroIn = e.isIntersecting; }
        if (e.target === form) { formIn = e.isIntersecting; }
      });
      set();
    });
    if (hero) { io.observe(hero); }
    if (form) { io.observe(form); }
    set();
  }

  function findTarget(id) {
    if (!id) { return null; }
    var el = document.getElementById(id);
    if (!el) {
      try { el = document.querySelector('[id$="__' + id.replace(/"/g, '') + '"]'); } catch (err) { el = null; }
    }
    return el;
  }

  function init(root) {
    root = root || document;
    each(root, '[data-sr-cg-swipe]', initSwipe);
    each(root, '[data-sr-cg-faq]', initFaq);
    each(root, '[data-sr-cg-fold-btn]', initFold);
    each(root, '.sr-cg-sticky', initSticky);
  }

  if (window.srCgInit) { window.srCgInit(document); return; }
  window.srCgInit = init;

  document.addEventListener('click', function (e) {
    var a = e.target.closest ? e.target.closest('.sr-cg a[href^="#"]') : null;
    if (!a) { return; }
    var id = a.getAttribute('href').slice(1);
    var el = findTarget(id);
    if (!el) { return; }
    e.preventDefault();
    var top = el.getBoundingClientRect().top + window.pageYOffset - 70;
    window.scrollTo({ top: top, behavior: reduce ? 'auto' : 'smooth' });
  });

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
})();